var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apple"},[_c('h1',[_vm._v("Test 1")]),_c('h2',[_vm._v("orderId: "+_vm._s(_vm.orderId))]),_c('div',{attrs:{"id":"apple"}}),_c('div',{staticClass:"apple-pay-button"})])
}
var staticRenderFns = []

export { render, staticRenderFns }